import React, { Component } from 'react';
import { Icon } from 'ui';
import TextArea from 'components/shared/debouncedTextArea';

class Choice extends Component {
  constructor(props) {
    super(props);

    this.destroy = this.destroy.bind(this);
    this.update = this.update.bind(this);
  }

  update(attribute, newValue) {
    const updatedChoice = {
      ...this.props.choice,
      [attribute]: newValue,
    };

    this.props.onUpdate(updatedChoice, updatedChoice.position);
  }

  destroy() {
    this.props.onDelete(this.props.choice);
  }

  getTranslations() {
    if (this.props.choice.correct) {
      return {
        label: t('questions.choices.correct.label'),
        textPlaceholder: t('questions.choices.correct.text_placeholder'),
        explanationPlaceholder: t(
          'questions.choices.correct.explanation_placeholder',
        ),
      };
    }

    return {
      label: t('questions.choices.incorrect.label'),
      textPlaceholder: t('questions.choices.incorrect.text_placeholder'),
      explanationPlaceholder: t(
        'questions.choices.incorrect.explanation_placeholder',
      ),
    };
  }

  render() {
    const { text, feedback, position } = this.props.choice;
    const i18n = this.getTranslations();
    const isAdditional = position > 2;

    return (
      <div>
        <div className="ChoiceElement--header">
          <div className="EditorElement-label ChoiceElement--header-label EditorElement-label--noPadding">
            {isAdditional
              ? t('questions.choices.incorrect.additional_label')
              : i18n.label}
          </div>
          {isAdditional && (
            <div className="ChoiceElement--header-remove">
              <Icon
                name="remove"
                className="c-brand-gray-dark EditorElement-controlButton"
                onClick={this.destroy}
              />
            </div>
          )}
        </div>
        <TextArea
          className="EditorElement-input"
          placeholder={i18n.textPlaceholder}
          value={text}
          name="text"
          onChange={newText => this.update('text', newText)}
          aria-label={`${this.props['aria-label']} ${t(
            'questions.choices.text_label',
          )}`}
        />
        <div>
          <div className="EditorElement-label EditorElement-label--shifted">
            {t('questions.choices.explanation_label')}
          </div>
          <TextArea
            className="EditorElement-input ChoiceElement--explanation"
            placeholder={i18n.explanationPlaceholder}
            value={feedback}
            name="explanation"
            onChange={newExplanation => this.update('feedback', newExplanation)}
            aria-label={`${this.props['aria-label']} ${t(
              'questions.choices.explanation_label',
            )}`}
          />
        </div>
        <hr />
      </div>
    );
  }
}

export default Choice;
